export default __webpack_public_path__ + "d5.png";